
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Hide, Show, Text, VStack } from '@chakra-ui/react'
import { useAuth } from 'context'
import { AuthLoginCredentialsType } from 'context/types'
import { LOGIN_SCHEMA } from 'context/validations'
import { Formik } from 'formik'
import { themeColors } from 'theme'

import { InputControl, SubmitButton } from 'components/InputCustom'
import { WicarLogo, WicarLogoSmall } from 'components/SVGS'
import { customToast } from 'components/ToastCustom'

export const Login = () => {
  const history = useNavigate()
  const {
    container: { gradientColor: { gradientOne, gradientTwo, gradientThree } },
    text: { bgDisabledText }
  } = themeColors
  const { login, clearError, authState: { error, loading, state: { user } } } = useAuth()
  const [copyPassword, setCopyPassword] = useState('')

  useEffect(() => {
    if (user && !user.consumerActive && copyPassword !== '')
      history('/validate-user', {
        state: {
          validateUser: {
            isLogin: true,
            user: {
              email: user.email,
              password: copyPassword,
              phoneNumber: user.phoneNumber
            },
          }
        }
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  const initialValues: AuthLoginCredentialsType = {
    email: '',
    password: '',
  }

  const handleOnSubmit = async ({ email, password }: AuthLoginCredentialsType) => {
    setCopyPassword(password)
    await login({ email, password })
  }

  useEffect(() => {
    error && customToast.showToast({ description: error })
    clearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error])

  return (
    <VStack
      minH={'100vh'}
      minW={'100vw'}
      bgGradient={`linear(to-b, ${gradientOne}, ${gradientTwo}, ${gradientThree})`}>
      <Formik
        enableReinitialize
        validateOnMount
        initialValues={initialValues}
        onSubmit={handleOnSubmit}
        validationSchema={LOGIN_SCHEMA}>
        <VStack
          flex={1}
          mx="auto"
          w={'full'}
          maxW={{ base: '90%', md: '550px' }}
          h={'fit-content'}
          rounded='2xl'
          p={{ base: 2, md: 4 }}
          justifyContent='center'
          alignItems='center'
          spacing={{ base: 4, md: '70px' }}>
          <VStack>
            <Show below='md'>
              <WicarLogoSmall width={50} height={50} />
            </Show>
            <Hide below='md'>
              <WicarLogo width={200} height={50} />
            </Hide>
          </VStack>
          <VStack w={'full'} justifyContent={'center'} alignItems={'center'} spacing={'60px'}>
            <VStack>
              <Text variant={'LG_SB'} textAlign={'center'}>¡Hola de nuevo!</Text>
              <Text textAlign={'center'}>
                Ingresa tu correo electrónico y contraseña para iniciar sesión
              </Text>
            </VStack>
            <VStack w={'full'} maxW={'330px'} spacing={'32px'}>
              <InputControl
                inputProps={{ placeholder: 'Ingresar correo electrónico' }}
                name='email'
                label='Correo electrónico'
                isDisabled={loading}
              />
              <InputControl
                inputType='password'
                inputProps={{ placeholder: 'Ingresa contraseña' }}
                name='password'
                isDisabled={loading}
                label='Contraseña' />
              <Text
                color={bgDisabledText}
                cursor={'pointer'}
                variant={'SM'}
                textDecorationLine={'underline'}
                onClick={() => history('/reset-password')}>
                ¿Olvidaste tu contraseña?
              </Text>
              <SubmitButton w={'full'} loadingText={'Ingresando...'} isLoading={loading}>
                iniciar sesión
              </SubmitButton>
              <Button onClick={() => history('/register')} variant={'secondary'} w={'full'} disabled={loading}>
                Regístrate
              </Button>
            </VStack>
          </VStack>
        </VStack>
      </Formik>
    </VStack>
  )
}
